import { render } from "./DatasetFromSelectionModal.vue?vue&type=template&id=74ede1d6&ts=true"
import script from "./DatasetFromSelectionModal.vue?vue&type=script&lang=ts"
export * from "./DatasetFromSelectionModal.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__